<template>
  <div id="rebate-list" class="container-float admin-wrap mt-5">
    <div>
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left" v-if="!initSelectedValue">{{ ddlSelectedValue }}</h3>
          <h3 class="text-left" v-else>{{ lang('Rebate') }}{{ lang('List') }}</h3>
        </div>
        <div class="col-lg-7">
          <el-tabs v-model="ddlSelectedValue" @tab-click="loadList()" v-if="!initSelectedValue">
            <el-tab-pane v-for="(items, i) in ddlSelection" :label="items.text" :name="items.value" :key="i"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="init-load" v-if="initSelectedValue">
        <button class="init-load_item" @click="initloadList('Rebate')">
          <img src="../assets/RebateList-Rebate.png" />
          {{ lang('Rebate') }}
        </button>
      </div>
      <div v-if="ddlRebateSelected">
        <rebate
          :propRebateListInt="RebateListInt"
          :propCurrentSchoolID="currentSchoolID"
          :propRebateListWithoutPayeeEmailInt="RebateListWithoutPayeeEmailInt"
          :propZipType="zipType"
          :propSpdSelection="spdSelection"
          @btnSendEmail="btnSendEmail"
          @btnSendEmailWithBreakdown="btnSendEmailWithBreakdown"
          @btnTestingSendEmail="btnTestingSendEmail"
          @btnTestingSendEmailWithBreakdown="btnTestingSendEmailWithBreakdown"
          @sendRebateEmail="sendRebateEmail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import rebate from '../components/InvoiceList/RebateList-Rebate'
import { lang } from '../locale/index'
export default {
  name: 'RebateList',
  components: {
    rebate,
  },
  async created() {
    // await this.Search();
    //await Cookies.get('schoolSession');
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  async mounted() {
    this.currentSchoolID = await Cookies.get('schoolSession')
  },
  data() {
    return {
      lang,
      currentSchoolID: '',
      zipType: '',
      ddlSelection: [{ text: lang('Rebate'), value: 'Rebate', imgUrl: '../assets/Rebatelist-Rebate.png' }],
      ddlSelectedValue: [],
      ddlRebateSelected: false,
      initSelectedValue: true,
      spdSelection: [],
      // selectedEmailSenderListInt:[],
      startupText: '',
      //start: More detail
      studentCourseID: '',
      studentID: '',
      courseStatus: '',
      //End:More detail
      datePicker: {
        disabledDate(date) {
          return date < new Date().getTime() - 1 * 24 * 60 * 60 * 1000
          //  Without using the second variable, you can replace 7 for with your back x days:
          //  e.g return date< Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        },
      },
      selectedData: [],

      // InvoiceListResp:[],
      InvoiceListInt: [],
      InvoiceListWithoutPayeeEmailInt: [],

      //receiptList:start
      ReceiptListInt: [],
      ReceiptListWithoutPayeeEmailInt: [],
      //receiptList:end

      RefundListAction: {
        label: lang('Info'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: '',
          },
        ],
      },
      RebateListInt: [],
      RebateList: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'Amount',
          label: lang('Amount'),
        },
        {
          prop: 'GstAmount',
          label: lang('Gst'),
        },
        {
          prop: 'TotalAmountIncGst',
          label: lang('TotalIncGst'),
        },
        {
          prop: 'OutstandingAmount',
          label: lang('Outstanding Amount'),
        },
        {
          prop: 'IH_Invoice_Name',
          label: lang('Invoice') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('CN') + lang('NO'),
        },
        {
          prop: 'IH_Invoice_Type',
          label: lang('Invoice') + lang('Type'),
        },
        {
          prop: 'email',
          label: lang('Payee') + lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
        {
          prop: 'fatherEmail',
          label: lang('Father') + lang('Email'),
        },
        {
          prop: 'motherEmail',
          label: lang('Mother') + lang('Email'),
        },
      ],

      RebateListWithoutPayeeEmailInt: [],
      RebateListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: lang('Student') + lang('Name'),
        },
        {
          prop: 'IH_Invoice_Status',
          label: lang('Invoice') + lang('Status'),
        },
        {
          prop: 'IH_Invoice_No',
          label: lang('Invoice') + lang('Name'),
        },
        {
          prop: 'email',
          label: lang('Email'),
        },
        {
          prop: 'sponsor_type',
          label: lang('Payee'),
        },
      ],
      RebateListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //RefundList:end

      AuditDisabled: false,
    }
  },
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initloadList(ddlSelectedValue) {
      this.ddlSelectedValue = ddlSelectedValue
      if (ddlSelectedValue === 'Rebate') {
        this.zipType = 'rebate'
        this.ddlRebateSelected = true
        this.initSelectedValue = false
      }
    },
    loadList() {
      if (this.ddlSelectedValue === 'Rebate') {
        this.zipType = 'rebate'
        this.ddlInvoiceSelected = false
        this.ddlReceiptSelected = false
        this.ddlCNSelected = false
        this.ddlRefundSelected = true
        this.initSelectedValue = false
      }
    },
    async clearTablesList() {
      this.InvoiceListInt = []
      this.InvoiceListWithoutPayeeEmailInt = []
    },
    async btnSendEmail(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
          // this.$refs.showBatchEmailConfirmationModal.hide();
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (payeeEmails !== m.fatherEmail && payeeEmails !== m.motherEmail) {
              payeeEmails += m.fatherEmail + ',' + m.motherEmail
              payeeEmails += ','
            } else {
              if (payeeEmails === m.fatherEmail && m.motherEmail !== '') {
                payeeEmails += m.motherEmail
                payeeEmails += ','
              }

              if (payeeEmails === m.motherEmail && m.fatherEmail !== '') {
                payeeEmails += m.fatherEmail
                payeeEmails += ','
              }
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
              }
              selectedObjList.push(list)
            }
          })
          let resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Receipt') {
            const recresp = await DataSource.shared.sendEmailReceipt(JSON.stringify(selectedObjList))
            resp = recresp
          } else {
            const invresp = await DataSource.shared.sendEmailRebate(JSON.stringify(selectedObjList))

            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              // this.selectedEmailSenderListInt=resp.Table;
              // this.$refs.showBatchEmailConfirmationModal.hide();

              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
              // window.location.replace('/invoicelist');
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnSendEmailWithBreakdown(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
          // this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide();
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (payeeEmails !== m.fatherEmail && payeeEmails !== m.motherEmail) {
              payeeEmails += m.fatherEmail + ',' + m.motherEmail
              payeeEmails += ','
            } else {
              if (payeeEmails === m.fatherEmail && m.motherEmail !== '') {
                payeeEmails += m.motherEmail
                payeeEmails += ','
              }

              if (payeeEmails === m.motherEmail && m.fatherEmail !== '') {
                payeeEmails += m.fatherEmail
                payeeEmails += ','
              }
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: payeeEmails,
              }
              selectedObjList.push(list)
            }
          })

          var resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Receipt') {
            const recresp = await DataSource.shared.sendEmailRebate(JSON.stringify(selectedObjList))
            resp = recresp
          } else {
            const invresp = await DataSource.shared.sendEmailRebate(JSON.stringify(selectedObjList))
            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              // this.selectedEmailSenderListInt=resp.Table;

              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
              // this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide();
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnTestingSendEmail(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          this.$refs.rebate.hideModal()
        } else {
          this.spdSelection = spdSelection
          this.clearTablesList()
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let payeeEmails = m.email + ','

            if (payeeEmails !== m.fatherEmail && payeeEmails !== m.motherEmail) {
              payeeEmails += m.fatherEmail + ',' + m.motherEmail
              payeeEmails += ','
            } else {
              if (payeeEmails === m.fatherEmail && m.motherEmail !== '') {
                payeeEmails += m.motherEmail
                payeeEmails += ','
              }

              if (payeeEmails === m.motherEmail && m.fatherEmail !== '') {
                payeeEmails += m.fatherEmail
                payeeEmails += ','
              }
            }

            payeeEmails = payeeEmails.substring(0, payeeEmails.length - 1)

            if (this.ddlSelectedValue === 'Receipt') {
              let list = {
                RH_Receipt_Name: m.RH_Receipt_Name,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: m.newTestEmail,
                RH_Receipt_No: m.RH_Receipt_Name,
                PK_Receipt_ID: m.PK_Receipt_ID,
              }
              selectedObjList.push(list)
            } else {
              let list = {
                IH_Invoice_No: m.IH_Invoice_No,
                studentID: m.FK_Student_ID,
                studentName: m.studentName,
                email: m.newTestEmail,
              }
              selectedObjList.push(list)
            }
          })

          var resp = {}
          //todo:
          if (this.ddlSelectedValue === 'Rebate') {
            const invresp = await DataSource.shared.sendEmailRebate(JSON.stringify(selectedObjList))
            resp = invresp
          }

          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              this.$refs.rebate.hideModal()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async btnTestingSendEmailWithBreakdown(value, spdSelection, sendType) {
      try {
        if (value === 'No') {
          if (sendType === 'invoice') {
            this.$refs.invoice.hideModal()
          } else {
            this.$refs.receipt.hideModal()
          }
        } else {
          this.spdSelection = spdSelection
          let selectedObjList = []
          this.spdSelection.forEach(m => {
            let list = {
              IH_Invoice_No: m.IH_Invoice_No,
              studentID: m.FK_Student_ID,
              studentName: m.studentName,
              email: m.newTestEmail,
            }
            selectedObjList.push(list)
          })

          const resp = await DataSource.shared.sendBreakdownEmail(JSON.stringify(selectedObjList))
          if (resp) {
            if (resp.code === '2') {
              this.$notify.error({
                title: 'Message',
                message: 'No Email Found',
              })
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Message',
                message: 'Cannot send email',
              })
            } else if (resp.code === '1') {
              this.$notify({
                title: 'Success',
                message: 'Send Success!',
                type: 'success',
              })
              if (sendType === 'invoice') {
                this.$refs.invoice.hideModal()
              } else {
                this.$refs.receipt.hideModal()
              }
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async sendRebateEmail(value, spdSelection, sendType) {
      console.log(value, spdSelection, sendType)
    },
    //Testing items only: end
  },
}
</script>

<style scoped>
.datatable-form__header .searchbtn {
  background: #4856ad;
  border-color: #4856ad;
  height: 37px;
  position: relative;
  top: 2px;
}

#rebate-list .header .el-select {
  margin-left: auto;
  display: table;
}

button.init-load_item img {
  width: 63px;
  display: block;
  margin: 0 auto 8px;
}

button.init-load_item {
  width: 150px;
  height: 150px;
  margin: 0 10px;
  border: 0;
  background: #f0c78a;
  color: white;
  padding: 20px 0;
  border-radius: 10px;
  cursor: pointer;
}

.init-load {
  /* display: flex; */
  padding: 20px 0;
}

button.init-load_item:hover {
  opacity: 0.8;
}

.rebateList-search_item label {
  margin: 0;
}
</style>
<style>
.rebateList-search_item {
  margin: 0 10px;
}

.rebateList-search_item .el-date-editor {
  max-width: 220px;
  padding: 0 !important;
  margin: 0;
  border-color: #eee !important;
}

.rebateList-search_item .el-date-editor i {
  display: none;
}

.rebateList-search_item .el-date-editor .el-range-separator {
  width: 10px;
  padding: 0;
  display: table;
  position: relative;
  top: 4px;
}

.rebateList-search_item .el-date-editor input {
  width: 100px;
  display: table;
}

.rebateList-search_item input {
  height: 35px;
  border-color: #eee;
}

.rebateList-search_wrap .datatable-form__header {
  border-bottom: 1px solid #edf0f4;
  padding-bottom: 20px;
  border-radius: 20px;
}
</style>
